export default __webpack_public_path__ + "static/media/checklist_white.590755ff.svg";